// src/App.jsx
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import ProjectPage from './pages/ProjectPage';

// Portada + una página por proyecto (src/projects/*.md). Las rutas antiguas redirigen a su sección.
// Blog oculto hasta tener posts reales (pages/Blog.jsx y pages/Post.jsx siguen en el repo).

function App() {
  // NO metas BrowserRouter/HashRouter aquí: ya está en main.jsx
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/projects/:slug" element={<ProjectPage />} />
        <Route path="/portfolio" element={<Navigate to="/#projects" replace />} />
        <Route path="/contact" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}

export default App;
